/**
 * DemolishTower use case: remove a tower, refund 50% mana, return gem to inventory.
 */

import { demolishTower as demolishTowerDomain } from "../../domain/session.js";
import type { RenderPort, AudioPort } from "../ports.js";
import { sessionToView } from "../state-view.js";
import type { GameSession } from "../../domain/session.js";

export interface DemolishTowerDeps {
  getSession: () => GameSession | null;
  render: RenderPort;
  audio?: AudioPort;
}

export function createDemolishTower(deps: DemolishTowerDeps) {
  return function demolishTower(towerId: string): { refund: number } | { code: "NotFound" } {
    const session = deps.getSession();
    if (!session) return { code: "NotFound" };
    const refund = demolishTowerDomain(session, towerId);
    if (refund === 0) return { code: "NotFound" };
    deps.audio?.play("build"); // reuse build sound
    deps.render.update(sessionToView(session, "game"));
    return { refund };
  };
}
